import '../../css/style.scss'
import {Sound} from '../../../shared/scripts/Sound'
import {UIMinimalHeaderController} from '../ui_html/new_layout/UIMinimalHeaderController'
import {UISidebarController} from '../ui_html/new_layout/UISidebarController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {UISingletonScrollController} from '../../../shared/scripts/ui_scroll_controller/UISingletonScrollController'
import {UIPatchNotes} from '../../../shared/scripts/patch_notes/UIPatchNotes'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'

void init()

async function init() {
    await EntryShared.initializeEntry()

    const sidebar = document.getElementById('patch_note_sidebar') as HTMLElement
    new UIPatchNotes(sidebar)

    const headerController = new UIMinimalHeaderController()
    new UISidebarController()

    new UISingletonScrollController()
    Sound.loadSounds()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
